<template>
  <div>
    <div class="base-text-align__right base-margin__bottom-10">
      <el-input
        v-model="projectIds"
        :placeholder="$t('projectManagement.enterProjectIds')"
        class="base-width__300"
        @change="changeProjectIds"
      ></el-input>
    </div>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('projectManagement.id')" prop="id" width="100"></el-table-column>
        <el-table-column :label="$t('projectManagement.teamName')" prop="name"></el-table-column>
        <el-table-column :label="$t('projectManagement.invitationCode')" prop="invitationCode"></el-table-column>
        <el-table-column :label="$t('projectManagement.teamAdminName')" prop="user.name"></el-table-column>
        <el-table-column :label="$t('projectManagement.computeClusterStatus')">
          <template slot-scope="scope">
            <el-tag :type="filterProjectStatus(scope.row.env.status).type">
              <span>{{ filterProjectStatus(scope.row.env.status).label }}</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('projectManagement.createTime')" prop="createTime"></el-table-column>
        <el-table-column :label="$t('projectManagement.actions')" width="480">
          <template slot-scope="scope">
            <el-button type="text" @click="openProjectInfo(scope.row.id)">{{
                $t('projectManagement.resourceOverview')
              }}
            </el-button>
            <el-button type="text" @click="getSubclusterList(scope.row.id, 'describeClusterNodes', false)"
            >{{ $t('projectManagement.teamComputeCluster') }}
            </el-button>
            <el-button type="text" @click="getSubclusterList(scope.row.id, 'subcluster', false)">
              {{ $t('projectManagement.teamCustomCluster') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <!--  资源概览 弹窗  -->
    <el-dialog :close-on-click-modal="false" :title="$t('projectManagement.resourceOverview')"
               :visible.sync="dialogVisible" width="500px">
      <el-form v-loading="projectInfoLoading" label-width="160px">
        <el-form-item :label="$t('projectManagement.masterNode')">
          <div>{{ projectInfo.masterNodeTotalCount }}</div>
        </el-form-item>
        <el-form-item :label="$t('projectManagement.computeClusterNode')">
          <div>{{ projectInfo.slurmNodeTotalCount }}</div>
        </el-form-item>
        <el-form-item :label="$t('projectManagement.elasticComputeNode')">
          <div>{{ projectInfo.batchNodeTotalCount }}</div>
        </el-form-item>
        <el-form-item :label="$t('projectManagement.subclusterTotal')">
          <div>{{ projectInfo.subclusterTotalCount }}</div>
        </el-form-item>
        <el-form-item :label="$t('projectManagement.subclusterNodeTotal')">
          <div>{{ projectInfo.subclusterNodeTotalCount }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--  集群列表 弹窗  -->
    <el-dialog :close-on-click-modal="false" :title="$t('projectManagement.clusterList')"
               :destroy-on-close="true"
               :visible.sync="subclusterDialogVisible"
               @close="handleCloseClusterList"
               width="1800px">
      <div class="subclusterTable">
        <div v-show="listType === 'subcluster'">
          <el-table :data="subclusterList" style="width: 100%">
            <el-table-column :label="$t('projectManagement.subclusterName')" fixed="left" prop="name"></el-table-column>
            <el-table-column :label="$t('projectManagement.id')" prop="id" width="80"></el-table-column>
            <el-table-column :label="$t('projectManagement.instanceType')" prop="instanceType"></el-table-column>
            <el-table-column :label="$t('projectManagement.imageId')" prop="imageId"></el-table-column>
            <el-table-column :label="$t('projectManagement.zone')" prop="zone"></el-table-column>
            <el-table-column :label="$t('projectManagement.vpc')" prop="vpcId"></el-table-column>
            <el-table-column :label="$t('projectManagement.subnet')" prop="subnetId"></el-table-column>
            <el-table-column :label="$t('projectManagement.createTime')" prop="createTime"></el-table-column>
            <el-table-column :label="$t('projectManagement.actions')" width="100">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="checkInstance(scope.row.id)">
                  {{ $t('projectManagement.viewInstance') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="listType === 'describeClusterNodes'">
          <div class="base-text-align__right">
            <el-select
              v-model="nodeType"
              :placeholder="$t('createNode.selectNodeType')"
              @change="changeNodeType"
              class="base-width__170"
            >
              <!-- 遍历节点类型选项 -->
              <el-option
                v-for="item in nodeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <el-table :data="subclusterList" style="width: 100%">
            <el-table-column :label="$t('projectManagement.instanceId')" fixed="left" prop="instanceId"
                             width="120"></el-table-column>
            <el-table-column :label="$t('projectManagement.nodeType')" prop="nodeType" width="100"></el-table-column>
            <el-table-column :label="$t('projectManagement.status')" width="70">
              <template slot-scope="scope">
                <span
                  :class="`${statusFilter(scope.row.status).class}`"
                  :style="`color:${statusFilter(scope.row.status).color};`"
                >
                  {{ statusFilter(scope.row.status).status }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.billingMethod')" width="118">
              <template slot-scope="scope">
                <span>{{
                    scope.row.instanceChargeType === 'PREPAID' ? $t('projectManagement.prepaid') : $t('projectManagement.payAsYouGo')
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.instanceType')" prop="instanceType"
                             width="140"></el-table-column>
            <el-table-column :label="$t('projectManagement.price')" width="120">
              <template slot-scope="scope">
                <span class="base-color__orange">
                  {{ ((scope.row.instancePrice * 100) / 100).toFixed(2) }}
                  {{
                    scope.row.instanceChargeType === 'PREPAID' ? $t('projectManagement.yuanPerMonth') : $t('projectManagement.yuanPerHour')
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.imageId')" prop="imageId" width="140"></el-table-column>
            <el-table-column :label="$t('projectManagement.imageType')" prop="imageType" width="100"></el-table-column>
            <el-table-column :label="$t('projectManagement.envId')" prop="envId" width="80"></el-table-column>
            <el-table-column :label="$t('projectManagement.region')" prop="zone" width="130"></el-table-column>
            <el-table-column :label="$t('projectManagement.publicPrivateIp')" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.publicIp || '-' }} / {{ scope.row.privateIp || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.subnet')" prop="subnetId" width="150"></el-table-column>
            <el-table-column :label="$t('projectManagement.hyperThreading')" width="138">
              <template slot-scope="scope">
                <span>{{
                    scope.row.hyperThreading ? $t('projectManagement.enabled') : $t('projectManagement.disabled')
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.scheduler')" width="90">
              <template slot-scope="scope">
                <span>{{ scope.row.workloadManager === 1 ? 'LSF' : 'slurm' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('projectManagement.createTime')" prop="createTime"
                             width="160"></el-table-column>
          </el-table>
        </div>
        <!-- 分页器 -->
        <el-pagination
          :page-size="10"
          :page-sizes="[10, 20, 50, 100]"
          :total="subclusterTotalCount"
          align="right"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="subclusterHandleSizeChange"
          @current-change="subclusterOnCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!--  子集群列表 弹窗  -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('projectManagement.teamWechatExpenseReport')"
      :visible.sync="enableExpenseReportVisible"
      width="800px"
    >
      <el-form ref="form" :model="reportForm" label-width="90px">
        <el-form-item :label="$t('projectManagement.cronExpression')">
          <el-input v-model="reportForm.cronExpression"
                    :placeholder="$t('projectManagement.enterCronExpression')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('projectManagement.robotUrl')">
          <el-input v-model="reportForm.wxRobotHook" :placeholder="$t('projectManagement.enterWxRobotUrl')"
                    type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="enableExpenseReportVisible = false">{{ $t('projectManagement.cancel') }}</el-button>
        <el-button type="primary" @click="startEnableExpenseReport()">{{ $t('projectManagement.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--  实例列表 抽屉  -->
    <el-drawer :title="$t('projectManagement.instanceList')" :visible.sync="instanceListDrawer" size="1200px" @close="instanceStatus === ''">
      <div>
        <el-select class="base-width__200 base-margin__bottom-20 base-margin__left-20" v-model="instanceStatus" placeholder="请选择" @change="checkInstance(subclusterId)">
          <el-option v-for="item in cvmStatusFilterList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-table :data="instanceList" style="width: 100%">
          <el-table-column :label="$t('projectManagement.id')" prop="id"></el-table-column>
          <el-table-column :label="$t('projectManagement.hostname')" prop="hostname"></el-table-column>
          <el-table-column :label="$t('projectManagement.instanceId')" prop="instanceId"></el-table-column>
          <el-table-column :label="$t('projectManagement.status')" prop="status"></el-table-column>
          <el-table-column :label="$t('projectManagement.instanceType')" prop="instanceType"></el-table-column>
          <el-table-column :label="$t('projectManagement.userId')" prop="userId"></el-table-column>
          <el-table-column :label="$t('projectManagement.ip')" prop="privateIp"></el-table-column>
          <el-table-column :label="$t('projectManagement.price')" width="200px">
            <template slot-scope="scope">
              <span class="base-flex__column-center">
                <span>
                  {{ $t('projectManagement.originalPrice') }}：{{ ((scope.row.price * 100) / 100).toFixed(2) }}
                  {{
                    scope.row.instanceChargeType === 'PREPAID' ? $t('projectManagement.yuanPerMonth') : $t('projectManagement.yuanPerHour')
                  }}
                </span>
                <span class="base-color__orange">
                  {{ $t('projectManagement.discountPrice') }}：{{ ((scope.row.priceDiscount * 100) / 100).toFixed(2) }}
                  {{
                    scope.row.instanceChargeType === 'PREPAID' ? $t('projectManagement.yuanPerMonth') : $t('projectManagement.yuanPerHour')
                  }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectManagement.createTime')" prop="createTime"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getRequest, postRequest } from '@/common/libs/request';
import { Message } from 'element-ui';
import {
  CvmStatusFilter,
  ENV_STATUS_INIT, NodeTypeFilterList,
  projectEnvStatusCleared,
  projectEnvStatusClearing,
  projectFilterStatus,
} from '@/common/constants';
import Cookies from 'js-cookie';
import i18n from '@/common/locales';

export default {
  name: 'projectManagement',
  data() {
    return {
      tableData: [], // 团队列表
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 团队列表总数
      dialogVisible: false,
      projectInfo: [],
      projectInfoLoading: false,
      projectEnvStatusCleared,
      projectEnvStatusInit: ENV_STATUS_INIT,
      projectEnvStatusClearing,
      subclusterDialogVisible: false, // 子集群列表弹窗
      subclusterList: [], // 子集群列表
      subclusterPageIndex: 1, // 分页index
      subclusterPageLimit: 10, // 每一页条数
      subclusterTotalCount: 0,
      projectId: 0,
      enableExpenseReportVisible: false, // 团队企业微信费用报告弹窗
      reportForm: {
        // 团队企业微信费用报告info
        cronExpression: '',
        wxRobotHook: '',
      },
      projectIds: '',
      instanceListDrawer: false,
      instanceList: [],
      listType: '',
      projectPriceBlacklist: sessionStorage.getItem('projectPriceBlacklist').split(',') || [], // 项目价格黑名单
      currentProjectInfo: JSON.parse(sessionStorage.getItem('currentProject')),
      currentProjectId: JSON.parse(sessionStorage.getItem('currentProject')).id || 0, // 当前项目ID
      cvmStatusFilterList: [
        {
          label: i18n.t('describeOperation.all'),
          value: '',
        },
        {
          label: i18n.t('common.constants.destroyed'),
          value: 'destroyed',
        },
        {
          label: i18n.t('common.constants.running'),
          value: 'running',
        },
      ],
      instanceStatus: '',
      subclusterId: 0,
      nodeType: '',
      nodeTypeList: [
        {
          label: i18n.t('describeOperation.all'),
          value: '',
        },
        ...NodeTypeFilterList,
      ],
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    // 打开团队企业微信费用报告弹窗 并清除数据
    // openEnableExpenseReportVisible(id) {
    //   this.projectId = id;
    //   this.reportForm = {
    //     cronExpression: '',
    //     wxRobotHook: '',
    //   };
    //   this.enableExpenseReportVisible = true;
    // },

    // 打开团队企业微信费用报告
    startEnableExpenseReport() {
      postRequest('/api/eda/common/admin/startExpenseReport', {
        ...this.reportForm,
        projectId: this.projectId,
      }).then(() => {
        Message.success(this.$t('projectManagement.openExpenseReportSuccess'));
        this.enableExpenseReportVisible = false;
        this.getList();
      });
    },
    // 关闭团队企业微信费用报告
    endExpenseReport(id) {
      this.$confirm(this.$t('projectManagement.closeExpenseReportConfirm'), this.$t('projectManagement.closeExpenseReport'), {
        confirmButtonText: this.$t('projectManagement.confirm'),
        cancelButtonText: this.$t('projectManagement.cancel'),
        type: 'warning',
      }).then(() => {
        postRequest('/api/eda/common/admin/stopExpenseReport', { projectId: id }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('projectManagement.closeExpenseReportSuccess'),
          });
          this.getList();
        });
      });
    },
    /**
     * 获取团队列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      const data = {
        offset,
        limit: this.pageLimit,
        projectIds: this.projectIds?.trim() === '' ? [] : this.projectIds.split(',').map(Number),
      };
      postRequest('/api/eda/common/admin/getProjectList', data).then((res) => {
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 查询项目支持项目ID筛选
     */
    changeProjectIds() {
      this.pageIndex = 1; // 分页index
      this.pageLimit = 10; // 每一页条数
      this.getList();
    },

    /**
     * 删除团队
     */
    deleteProject(id) {
      this.$confirm(this.$t('projectManagement.deleteTeamConfirm'), this.$t('projectManagement.deleteTeam'), {
        confirmButtonText: this.$t('projectManagement.confirm'),
      })
        .then(() => {
          postRequest('api/eda/common/admin/destroyProject', { projectId: +id }).then(() => {
            this.getList();
            if (+this.currentProjectId === +id) {
              // 清除当前团队
              Cookies.remove('CurrentProject');
              window.sessionStorage.removeItem('currentProject');
            }
            this.$store.dispatch('app/getProjectList');
            Message.success(this.$t('projectManagement.deleteTeamSuccess'));
          });
        })
        .catch(() => {
        });
    },

    // 清除团队数据
    closeProjectData(id) {
      this.$confirm(this.$t('projectManagement.clearDataConfirm'), this.$t('projectManagement.clearTeamData'), {
        confirmButtonText: this.$t('projectManagement.confirm'),
      })
        .then(() => {
          postRequest('/api/eda/common/admin/terminateClusterNode', { projectId: +id }).then(() => {
            this.getList();
            Message.success(this.$t('projectManagement.clearingData'));
          });
        })
        .catch(() => {
        });
    },

    /**
     * 团队节点详情
     */
    openProjectInfo(id) {
      this.dialogVisible = true;
      this.projectInfoLoading = true;
      getRequest(`/api/eda/common/admin/describeProjectStatistics?projectId=${id}`).then((res) => {
        this.projectInfo = res;
        this.projectInfoLoading = false;
      });
    },

    /**
     * 转团队状态
     */
    filterProjectStatus(val) {
      return projectFilterStatus.filter(item => item.value === +val)[0];
    },

    /**
     * 切换节点类型
     */
    changeNodeType() {
      this.getSubclusterList(this.projectId, this.listType, false);
    },

    /**
     * 关闭集群列表
     */
    handleCloseClusterList() {
      this.subclusterDialogVisible = false;
      this.projectId = '';
      this.listType = '';
      this.subclusterList = [];
      this.subclusterPageIndex = 1; // 分页index
      this.subclusterPageLimit = 10; // 每一页条数
      this.subclusterTotalCount = 0; // 总条数
      this.nodeType = '';
    },

    /**
     * 获取团队子集群列表   获取团队计算集群列表
     */
    getSubclusterList(projectId, type, isPagination) {
      if (!isPagination) {
        this.subclusterPageIndex = 1; // 分页index
        this.subclusterPageLimit = 10; // 每一页条数
        this.subclusterTotalCount = 0; // 总条数
      }
      this.subclusterList = [];
      this.subclusterTotalCount = 0; // 总条数
      this.projectId = projectId;
      this.listType = type;
      const offset = this.subclusterPageLimit * (this.subclusterPageIndex - 1);

      if (type === 'subcluster') {
        postRequest('/api/eda/common/admin/getSubclusterList', {
          projectId: this.projectId,
          offset,
          limit: this.subclusterPageLimit,
        }).then((res) => {
          this.subclusterDialogVisible = true;
          this.subclusterList = res?.subclusterList || [];
          this.subclusterTotalCount = res?.totalCount || 0;
        });
      } else {
        postRequest('/api/eda/common/admin/describeClusterNodes', {
          projectId: this.projectId,
          offset,
          limit: this.subclusterPageLimit,
          nodeType: this.nodeType,
        }).then((res) => {
          this.subclusterDialogVisible = true;
          this.subclusterList = res?.list || [];
          this.subclusterTotalCount = res?.total || 0;
        });
      }
    },

    // 子集群列表分页
    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    subclusterOnCurrentChange(val) {
      this.subclusterPageIndex = val;
      this.getSubclusterList(this.projectId, this.listType, true);
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    subclusterHandleSizeChange(val) {
      this.subclusterPageLimit = val;
      this.getSubclusterList(this.projectId, this.listType, true);
    },

    // 团队信息分页
    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },

    /**
     * 查看实例
     */
    checkInstance(val) {
      this.subclusterId = val;
      const data = {
        projectId: this.projectId,
        subclusterId: val,
      };
      this.instanceList = [];
      postRequest('/api/eda/common/admin/getSubclusterInstanceList', data).then((res) => {
        this.instanceListDrawer = true;
        if (this.instanceStatus === '') {
          this.instanceList = res?.instanceList || [];
        }
        if (this.instanceStatus === 'running') {
          this.instanceList = res?.instanceList.filter(item => item.endAt === 0);
        }
        if (this.instanceStatus === 'destroyed') {
          this.instanceList = res?.instanceList.filter(item => item.endAt !== 0);
        }
      });
    },

    /**
     * 状态过滤
     * @param {*} val 节点状态
     */
    statusFilter(val) {
      switch (val) {
        case CvmStatusFilter.CvmStatusCreate:
          return { status: this.$t('projectManagement.creating'), class: 'status__color-create' };
        case CvmStatusFilter.CvmStatusNormal:
          return { status: this.$t('projectManagement.normal'), class: 'status__color-Normal' };
        case CvmStatusFilter.CvmStatusAbnormal:
          return { status: this.$t('projectManagement.abnormal'), class: 'status__color-InDestruction' };
        case CvmStatusFilter.CvmStatusInDestruction:
          return { status: this.$t('projectManagement.destroying'), class: 'status__color-Destruction' };
        case CvmStatusFilter.CvmStatusDestruction:
          return { status: this.$t('projectManagement.destroyed'), class: 'status__color-Abnormal' };
        case CvmStatusFilter.CvmStatusInDeployment:
          return { status: this.$t('projectManagement.deploying'), class: 'status__color-create' };
        default:
          return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}


// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 400px;
    //max-height: 400px;
  }
}

.subclusterTable {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 400px;
  }
}

.ellipsis_nowrap_cls {
  overflow: hidden;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.spanCls {
  width: 50px;
  line-height: 40px;
}

.status__color-create {
  color: #165bcf;
}

.status__color-Normal {
  color: #0bc740;
}

.status__color-InDestruction,
.status__color-Destruction,
.status__color-Abnormal {
  color: #d12734;
}
</style>
